import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

import "./McaCourse.css";
import {
  FaClock,
  FaLaptop,
  FaUserCheck,
  FaBookOpen,
  FaHandsHelping,
} from "react-icons/fa";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Accordion,
  Form,
} from "react-bootstrap";
import { FaUniversity, FaGraduationCap, FaBook } from "react-icons/fa";
import { FaLayerGroup } from "react-icons/fa";
import { FaChartLine, FaHandshake, FaUsers } from "react-icons/fa";
import Slider from "react-slick";
import { FaPlus, FaMinus } from "react-icons/fa"; // ✅ using react-icons
import {
  FaSnowflake,
  FaUser,
  FaDollarSign,
  FaBuilding,
  FaTruck,
  FaPhoneAlt,
} from "react-icons/fa";
import Admission from "../../components/Admission";
import Partner from "../../components/Partner";

export default function McaCourse() {
  const careers = [
    {
      icon: "💻",
      title: "Accountant",
    },
    {
      icon: "🌐",
      title: "Financial Analyst",
    },
    {
      icon: "📊",
      title: "Tax Consultant",
    },
    {
      icon: "🖥️",
      title: "Auditor",
    },
    {
      icon: "🗄️",
      title: "Banking Professional",
    },
    {
      icon: "☁️",
      title: "Corporate Finance Executive",
    },
    {
      icon: "🔐",
      title: "Corporate Finance Executive",
    },
    {
      icon: "📂",
      title: "Business Consultant",
    },
  ];

  const universities = [
    {
      name: "Subharti University",
      logo: "/images/subharti.png",
    },
    {
      name: "IGNOU",
      logo: "/images/ignou.png",
    },
    {
      name: "Andhra University",
      logo: "/images/andhra.png",
    },
    {
      name: "Amity University",
      logo: "/images/amity.png",
    },
    {
      name: "Lovely Professional University (LPU)",
      logo: "/images/lpu.png",
    },
    {
      name: "Sikkim Manipal University",
      logo: "/images/smu.png",
    },
    {
      name: "Chandigarh University",
      logo: "/images/chandigarh.png",
    },
    {
      name: "Jain University",
      logo: "/images/jain.png",
    },
    {
      name: "Annamalai University",
      logo: "/images/annamalai.png",
    },
    {
      name: "Delhi University (School of Open Learning)",
      logo: "/images/du.png",
    },
    {
      name: "Madras University",
      logo: "/images/madras.png",
    },
  ];

  const highlights = [
    {
      icon: "⏰",
      title: "Course Duration",
      description:
        "2 years (4 semesters) — designed for efficient learning while balancing work or other commitments.",
    },
    {
      icon: "📚",
      title: "Learning Mode",
      description:
        "Distance / Online — study from anywhere with access to online classes, study material, and recorded lectures.",
    },
    {
      icon: "🔍",
      title: "Eligibility",
      description:
        "A bachelor's degree (preferably BCA, B.Sc CS/IT) with Mathematics in 10+2 or graduation.",
    },
    {
      icon: "🏛️",
      title: "University Recognition",
      description:
        "Courses offered are from UGC and AICTE-approved universities, ensuring your degree is valid and recognized.",
    },
    {
      icon: "📖",
      title: "Curriculum",
      description:
        "Covers core programming, software engineering, DBMS, networking, cloud computing, and more.",
    },
    {
      icon: "🎧",
      title: "Support & Flexibility",
      description:
        "Study on your schedule with weekend sessions, recorded classes, student support, and online doubt-solving.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const data = [
    { icon: <FaChartLine />, number: "100%", label: "Success Rate" },
    { icon: <FaHandshake />, number: "35+", label: "Years Of Service" },
    { icon: <FaUsers />, number: "8k+", label: "Students" },
    { icon: <FaBook />, number: "10+", label: "Courses" },
  ];

  const plans = [
    {
      id: "01",
      color: "#00c6ff",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "02",
      color: "#2ecc71",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "03",
      color: "#f1c40f",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "04",
      color: "#e67e22",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "05",
      color: "#9b59b6",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "06",
      color: "#2980b9",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
  ];

  const steps = [
    {
      num: "1",
      title: "Fill the Application Form",
      text: "Establishing goals & blueprints for the new website",
      icon: "🔍",
    },
    {
      num: "2",
      title: "Document Verification",
      text: "Defining information architecture & content plan",
      icon: "📝",
    },
    {
      num: "3",
      title: "Confirm Admission & Pay Fees",
      text: "Designing the form & function of the website",
      icon: "🎨",
    },
  ];

  const blogs = [
    {
      title: "Writing Class",
      image: "https://via.placeholder.com/400x250?text=Writing+Class",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Crafts Activities",
      image: "https://via.placeholder.com/400x250?text=Crafts+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Math Activities",
      image: "https://via.placeholder.com/400x250?text=Math+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
  ];

  const faqData = [
    {
      question: "What is a Distance M.Com program?",
      answer:
        "A Distance M.Com is a postgraduate commerce degree offered through online or correspondence mode, focusing on accounting, finance, business management, and economics without the need for regular campus attendance.",
    },
    {
      question: "Is a Distance M.Com recognized and valid for jobs?",
      answer:
        "Yes. A Distance M.Com from a UGC-approved university is valid for private and government jobs, as well as for pursuing professional certifications like CA, CMA, or higher studies such as PhD or MBA.",
    },
    {
      question:
        "What are the eligibility criteria for M.Com distance education?",
      answer:
        "Applicants generally need a B.Com or an equivalent bachelor’s degree in commerce, economics, or related fields from a recognized university.",
    },
    {
      question: "How long does it take to complete a Distance M.Com?",
      answer:
        "Most Distance M.Com programs take 2 years to complete, though some universities allow an extended duration of up to 4–5 years for flexibility.",
    },
    {
      question: "Can I work while pursuing a Distance M.Com?",
      answer:
        "Yes. Distance M.Com programs are designed for working professionals and students who need flexibility, allowing them to balance work and studies effectively.",
    },
    {
      question:
        "What career opportunities are available after a Distance M.Com?",
      answer:
        "Graduates can build careers in accounting, auditing, banking, financial analysis, taxation, corporate finance, or pursue advanced certifications like CA, CFA, or CS.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const features = [
    {
      id: 1,
      icon: <FaClock size={36} className="text-primary mb-3" />,
      title: "Course Duration",
      description:
        "Typically 2 years (4 semesters), with some universities offering flexible timelines. Designed for working professionals, students can complete M.Com distance education in Bangalore at their own pace.",
    },
    {
      id: 2,
      icon: <FaLaptop size={36} className="text-success mb-3" />,
      title: "Learning Mode",
      description:
        "100% online or blended learning through digital platforms, recorded lectures, study materials, and virtual classrooms, making online M.Com courses in Bangalore convenient for learners across India.",
    },
    {
      id: 3,
      icon: <FaUserCheck size={36} className="text-warning mb-3" />,
      title: "Eligibility",
      description:
        "Bachelor’s degree in commerce, finance, or related fields (B.Com, BBA, etc.) from a recognized university, required to enroll in distance M.Com colleges in Bangalore.",
    },
    {
      id: 4,
      icon: <FaUniversity size={36} className="text-info mb-3" />,
      title: "University Recognition",
      description:
        "Programs are offered by UGC-approved M.Com distance education universities, ensuring academic credibility, corporate acceptance, and eligibility for promotions, research, or higher studies.",
    },
    {
      id: 5,
      icon: <FaBookOpen size={36} className="text-danger mb-3" />,
      title: "Curriculum",
      description:
        "Covers accounting, finance, taxation, business law, economics, research methods, and electives, providing comprehensive knowledge through best M.Com distance learning colleges in Bangalore.",
    },
    {
      id: 6,
      icon: <FaHandsHelping size={36} className="text-secondary mb-3" />,
      title: "Support & Flexibility",
      description:
        "Students receive academic counseling, mentorship, online support, and flexible exam schedules, making M.Com correspondence courses in Bangalore ideal for professionals balancing work and studies.",
    },
  ];

  const highlightsData = [
    {
      icon: <FaClock size={36} className="text-primary mb-3" />,
      title: "Course Duration",
      description:
        "Typically 2 years (4 semesters), with some universities offering flexible timelines. Designed for working professionals, students can complete M.Com distance education in Bangalore at their own pace.",
    },
    {
      icon: <FaLaptop size={36} className="text-success mb-3" />,
      title: "Learning Mode",
      description:
        "100% online or blended learning through digital platforms, recorded lectures, study materials, and virtual classrooms, making online M.Com courses in Bangalore convenient for learners across India.",
    },
    {
      icon: <FaUserCheck size={36} className="text-warning mb-3" />,
      title: "Eligibility",
      description:
        "Bachelor’s degree in commerce, finance, or related fields (B.Com, BBA, etc.) from a recognized university, required to enroll in distance M.Com colleges in Bangalore.",
    },
    {
      icon: <FaUniversity size={36} className="text-info mb-3" />,
      title: "University Recognition",
      description:
        "Programs are offered by UGC-approved M.Com distance education universities, ensuring academic credibility, corporate acceptance, and eligibility for promotions, research, or higher studies.",
    },
    {
      icon: <FaBookOpen size={36} className="text-danger mb-3" />,
      title: "Curriculum",
      description:
        "Covers accounting, finance, taxation, business law, economics, research methods, and electives, providing comprehensive knowledge through best M.Com distance learning colleges in Bangalore.",
    },
    {
      icon: <FaHandsHelping size={36} className="text-secondary mb-3" />,
      title: "Support & Flexibility",
      description:
        "Students receive academic counseling, mentorship, online support, and flexible exam schedules, making M.Com correspondence courses in Bangalore ideal for professionals balancing work and studies.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Best Online M.Com Colleges & Distance Learning in Bangalore
        </title>
        <meta
          name="description"
          content="Join UGC-approved M.Com online and distance courses in Bangalore. Study at the best M.Com distance learning colleges with flexible programs."
        />
      </Helmet>

      <div className="mca-course-page">
        {/* ===== MCA Course Header ===== */}
        <section className="mca-course-header py-5 text-white">
          <Container>
            <Row className="align-items-center">
              {/* MCA Course Info */}
              <Col md={7} className="mca-course-header-content">
                <span className="mca-course-badge badge bg-warning text-dark mb-3">
                  Live Classes
                </span>
                <h1 className="mca-course-title fw-bold mb-3">
                  Master of Commerce (M.Com){" "}
                </h1>
                <p className="mca-course-subtitle lead mb-3">
                  This MCA program is designed to build a strong foundation in
                  computer applications, programming, software development, and
                  IT management. You’ll gain advanced skills required for
                  careers in the tech industry.
                </p>
                <Button
                  variant="warning"
                  size="lg"
                  className="mca-course-enroll-btn fw-bold"
                >
                  Get admitted to the batch
                </Button>

                {/* MCA Course Rating */}
                <div className="mca-course-rating mt-3 d-flex align-items-center">
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <span className="ms-2">(4.8)</span>
                </div>
              </Col>

              {/* MCA Course Thumbnail */}
              <Col md={5} className="mca-course-header-thumbnail text-center">
                <img
                  src="/images/mcom3-removebg-preview.png"
                  alt="MCA Course Preview"
                  style={{ height: "400px", marginTop: "40px" }}
                />
              </Col>
            </Row>
          </Container>
        </section>

        {/* ===== MCA Course Content Section ===== */}

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              M.Com Distance Education – Advance Your Expertise in Commerce &
              Finance
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              The Master of Commerce (M.Com) distance education program is ideal
              for students and working professionals aiming to deepen their
              knowledge in accounting, finance, taxation, and business
              management. Designed to combine academic theory with practical
              applications, it equips learners with analytical, managerial, and
              problem-solving skills for high-growth roles in commerce-related
              industries. Through M.Com distance education in Bangalore,
              learners can earn a degree from UGC-approved M.Com distance
              education universities while managing work or personal
              commitments. The program is flexible, accessible, and suitable for
              careers in finance, banking, corporate consultancy, teaching, or
              research. With a comprehensive curriculum, experienced faculty,
              and digital learning platforms, online M.Com courses in Bangalore
              provide quality education without regular classroom attendance.
              Offered by distance M.Com colleges in Bangalore and best M.Com
              distance learning colleges in Bangalore, this program ensures
              practical skills, career advancement, and further academic
              opportunities. Enroll in a M.Com correspondence course in
              Bangalore to gain a recognized degree from UGC-approved M.Com
              online institutions.
            </p>
          </Container>
        </section>

        <section
          style={{ background: "linear-gradient(to right, #f9fafb, #eef2ff)" }}
          className="py-5"
        >
          <Container>
            {/* Heading */}
            <div className="text-center mb-5">
              <h2 className="fw-bold text-dark display-6">
                Key Highlights of the M.Com Distance Education Program
              </h2>
              <p className="text-muted fs-5 mt-3 px-md-5">
                Making quality education accessible, flexible, and
                career-focused for learners across India.
              </p>
            </div>

            {/* Highlights Grid */}
            <Row className="g-4">
              {highlightsData.map((highlight, index) => (
                <Col md={6} key={index}>
                  <Card className="h-100 shadow border-0 text-center">
                    <Card.Body>
                      {highlight.icon}
                      <h5 className="fw-bold">{highlight.title}</h5>
                      <p className="text-muted">{highlight.description}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              M.Com Distance Education – Strengthen Your Future in Commerce &
              Finance
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              Pursuing an M.Com distance education is an excellent choice for
              commerce graduates seeking advanced knowledge in financial
              systems, business strategies, and economic policies while studying
              flexibly from anywhere. This program suits working professionals,
              aspiring lecturers, and students preparing for competitive exams
              or research opportunities. The curriculum includes core subjects
              like financial accounting, corporate law, business environment,
              taxation, auditing, and managerial economics. It combines
              theoretical knowledge with practical insights, enabling learners
              to apply concepts in real-world finance and commerce scenarios.
              Elective specializations allow alignment with career goals in
              banking, insurance, taxation, or investment analysis. Distance
              M.Com colleges in Bangalore and best M.Com distance learning
              colleges in Bangalore offer programs from UGC-approved M.Com
              distance education universities. Students can access materials
              online, attend virtual classes, and take exams at their
              convenience. Whether aiming for a career in commerce, qualifying
              for UGC NET, or pursuing a Ph.D., an M.Com correspondence course
              in Bangalore provides a strong foundation for success.
            </p>
          </Container>
        </section>

        <section className="why-section">
          <div className="why-head">
            <h1>Why Choose M.COM via Distance Education?</h1>
          </div>
          <div className="why-container">
            {/* Left image */}
            <div className="why-image">
              <img
                src="/images/whychoose.jpg"
                alt="Why Choose Bangalore Distance Education for Your M.Com Distance Education"
              />
            </div>

            {/* Right content */}
            <div className="why-content">
              <p className="section-text">
                Distance M.Com programs are increasingly popular among students
                and working professionals seeking to advance their careers
                without affecting current commitments. Choosing M.Com distance
                education in Bangalore offers flexibility, affordability, and a
                recognized degree.
              </p>

              <div className="features-grid">
                {features.map((item, idx) => (
                  <div key={idx} className="feature-card">
                    <div className="feature-icon">{item.icon}</div>
                    <div>
                      <h3 className="feature-title">{item.title}</h3>
                      <p className="feature-text">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Admission Process */}

        <Admission></Admission>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h1 className="text-center mb-5">
              Career Opportunities After M.COM
            </h1>
            <p
              className="text-center mb-5"
              style={{ color: "#666", fontSize: "16px" }}
            >
              Earning an MCA through distance education opens up diverse career
              opportunities in the growing tech industry. With advanced
              knowledge in programming, software systems, and IT management, MCA
              graduates are highly sought after in both private and public
              sectors.
            </p>

            {/* Career Grid */}
            <Row className="text-center">
              {careers.map((career, index) => (
                <Col key={index} xs={12} sm={6} md={3} className="mb-4">
                  <div style={{ fontSize: "48px" }}>{career.icon}</div>
                  <h6 className="fw-bold mt-3">{career.title}</h6>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <Partner></Partner>

        <Container className="my-5">
          <Row className="justify-content-center">
            <Col md={10} lg={8}>
              <h1 className="fw-bold display-6 mb-3">
                Take the Next Step with Our Distance M.Com Program
              </h1>
              <p className="text-muted fs-5">
                Looking to advance your career in commerce or finance? Our
                UGC-approved M.Com distance education in Bangalore program is
                designed for ambitious learners seeking expertise in accounting,
                taxation, and business strategy—all from home. Whether you are a
                B.Com graduate, working professional, or preparing for
                competitive exams, online M.Com courses in Bangalore provide
                flexibility, affordability, and an industry-aligned curriculum
                to help you grow professionally. Fill out the form to receive
                expert guidance on admissions, course details, and university
                selection. Begin your journey with M.Com distance education, and
                take the next step toward achieving your career and academic
                goals confidently.
              </p>
            </Col>
          </Row>
        </Container>

        {/* Register Now */}

        <div className="event-wrapper">
          {/* Curved shape */}
          <div className="curve"></div>

          {/* Left section */}
          <div className="left-section">
            <br />
            <h2>WE APPRECIATE ALL YOU DO</h2>
            <h3>Take the Next Step with Our Distance M.Com Program</h3>
            <p>
              Looking to advance your career in commerce or finance? Our
              UGC-approved M.Com program is designed for ambitious learners who
              want to deepen their expertise in accounting, taxation, and
              business strategy — all while studying from the comfort of home.
              Whether you’re a B.Com graduate, a working professional, or
              preparing for academic and competitive exams, this course offers
              the flexibility, affordability, and industry-aligned curriculum
              you need to grow. Fill out the form to receive expert guidance on
              admissions, course details, and university options — and take the
              next step in your M.Com journey with confidence.
            </p>
          </div>

          {/* Right section */}
          <div className="right-section">
            <form className="form-card">
              <h2>Registration</h2>
              <hr className="divider" />

              <input type="text" placeholder="Full Name*" />
              <input type="email" placeholder="Email*" />
              <input type="number" name="" id="" placeholder="Phone" />

              <button type="submit" className="register-btn">
                Register
              </button>

              <p className="footer-note">Your perfect events registrations</p>
            </form>
          </div>
        </div>

        {/* FAQ */}
        <section className="faq-section py-5">
          <Container>
            <Row>
              <h1 className="text-center mb-5">
                Frequently Asked Questions (FAQ)
              </h1>
            </Row>

            <Row>
              {faqData.map((faq, index) => (
                <Col md={6} key={index} className="mb-4">
                  <div
                    className={`faq-card ${
                      openIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-question">
                      <span>{faq.question}</span>
                      <span className="faq-icon">
                        {openIndex === index ? <FaMinus /> : <FaPlus />}
                      </span>
                    </div>
                    {openIndex === index && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
